/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CommercialFindingStatus {
    Active = 0,
    Resolved = 1,
    Dismissed = 2,
}
